import { defineMessages } from 'react-intl'

const scope = `procurify.components.CatalogItemIndicator`

export default defineMessages({
  tooltipText: {
    id: `${scope}.tooltipText`,
    defaultMessage: 'This is a catalog item',
  },
  imageDescription: {
    id: `${scope}.imageDescription`,
    defaultMessage: 'Catalog item indicator',
  },
})
